import { render } from "./ProfessionalCustomerForm.vue?vue&type=template&id=635cb68d"
import script from "./ProfessionalCustomerForm.vue?vue&type=script&lang=js"
export * from "./ProfessionalCustomerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__